<script setup lang="ts">
import { DocumentTextIcon } from '@heroicons/vue/24/outline'
import { highlight } from '@/utils/highlight'
import type { OsQuoteResult } from '@/api/omnisearchApi'

defineProps<{
  item: OsQuoteResult
  query: string
}>()
// Pas de page dédiée pour les devis pour l'instant
</script>

<template>
  <div class="flex items-start gap-3 px-3 py-2.5 rounded-lg text-left">
    <span class="mt-0.5 flex-shrink-0 w-8 h-8 rounded-md bg-cyan-100 dark:bg-cyan-900/30 flex items-center justify-center">
      <DocumentTextIcon class="w-4 h-4 text-cyan-600 dark:text-cyan-400" />
    </span>
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium truncate text-base-content" v-html="highlight(item.quoteReference, query)" />
      <div class="flex flex-wrap gap-x-3 gap-y-0.5 mt-0.5">
        <span v-if="item.customerReference" class="text-xs text-base-content/60">
          Réf client : <span v-html="highlight(item.customerReference, query)" />
        </span>
        <span v-if="item.order" class="text-xs text-base-content/50">1 commande</span>
        <span v-if="item.regulations.length" class="text-xs text-base-content/50">
          {{ item.regulations.length }} régulation{{ item.regulations.length > 1 ? 's' : '' }}
        </span>
      </div>
    </div>
    <span class="badge badge-ghost badge-xs self-center flex-shrink-0">pas de lien</span>
  </div>
</template>
